import type { RouteConfig } from 'react-router-config'
import { withAsync } from '@/components/Async'
import Blank from '@/layouts/Blank'

const routes: RouteConfig[] = [
  {
    path: '/helps',
    component: Blank,
    permissionCode: 'helps:guide',
    routes: [
      {
        path: '/guide',
        name: 'guide',
        component: withAsync(() => import(/* webpackChunkName: "Guide" */ '@/containers/Guide')),
        exact: true,
        main: true,
      },
      {
        path: '/couriers',
        name: 'couriers',
        component: withAsync(() => import(/* webpackChunkName: "Couriers" */ '@/containers/Couriers')),
        exact: true,
        main: true,
      },
      /** 生态服务 */
      {
        path: '/eco',
        component: withAsync(() => import(/* webpackChunkName: "Eco" */ '@/containers/Eco')),
        menuTitle: 'help.eco',
        exact: true,
        main: true,
      },
    ],
  },
]

export default routes
